<template>
  <div id="app">
    <!-- <router-view/> -->
    <router-view v-if="isRouteAlive"/>
  </div>
</template>

<script>
  export default {
    name: 'App',
     provide () {
        return {
          reload: this
        }
      },
      data () {
        return {
          isRouteAlive: true
        }
      },
      methods: {
          reload () {
            this.isRouteAlive = false
            this.$nextTick (() => {
              this.isRouteAlive = true
            })
          }
        }
  }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue